import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
// import profileDetailsReducer, {
//     IProfileDetailsState
// } from "./reducers/profile-details/profile-details-reducer";
// import profileMembershipReducer, {
//     IProfileMembershipState
// } from "./reducers/profile-membership/profile-membership-reducer";
// import signupReducer, { ISignupState } from "./reducers/signup/signup-reducer";
import errorHandlingReducer, { IErrorState } from "./reducers/error-handling/error-handling-reducer";
// import basketReducer, { IBasketState } from "./reducers/basket/basket-reducer";
// import bonusPointsReducer, { IBonusPointsState } from "./reducers/bonus-points/bonus-points-reducer";
import searchReducer, { ISearchState } from "./reducers/search/search-reducer";
import bookOfTheMonthReducer, {
    IBookOfTheMonthState
} from "./reducers/book-of-the-month/book-of-the-month-reducer";
// import returnCodeReducer, { IReturnCodeState } from "~/store/reducers/return-code/return-code-reducer";
import authorReducer, { AuthorState } from "./reducers/author/author-reducer";
import teaserReducer, { TeaserState } from "./reducers/teasers/teaser-reducer";
// import upgradeMembershipReducer, {
//     IUpgradeMembershipState
// } from "./reducers/upgrade-membership/upgrade-membership-reducer";
// import voucherReducer, { IVoucherState } from "./reducers/voucher/voucher-reducer";
// import notificationsReducer, { INotificationsState } from "./reducers/notifications/notifications-reducer";

// The "any" reducers have been typed that way to satisfy TS, they are actually disabled.
export interface IRootState {
    basket: any;
    bonusPoints: any;
    bookOfTheMonth: IBookOfTheMonthState;
    error: IErrorState;
    profileDetails: any;
    profileMembership: any;
    returnCode: any;
    search: ISearchState;
    signup: any;
    voucher: any;
    upgradeMembership: any;
    author: AuthorState;
    notifications: any;
    teasers: TeaserState;
}

export default function createRootReducer() {
    return combineReducers<IRootState | undefined>({
        author: authorReducer,
        // basket: basketReducer,
        // bonusPoints: bonusPointsReducer,
        bookOfTheMonth: bookOfTheMonthReducer,
        error: errorHandlingReducer,
        form: formReducer,
        // notifications: notificationsReducer,
        // profileDetails: profileDetailsReducer,
        // profileMembership: profileMembershipReducer,
        // returnCode: returnCodeReducer,
        search: searchReducer,
        // signup: signupReducer,
        teasers: teaserReducer
        // upgradeMembership: upgradeMembershipReducer,
        // voucher: voucherReducer
    } as any);
}
